import { Button, Modal, Text } from '@mercai/clever'

import { QuotationsModalProps } from './quotations-modal.types'

import { useTranslation } from 'react-i18next'
import styles from './quotations-modal.module.css'

import { ROUTES_ADMIN } from '@/router'
import { useSaleOrderVariantList } from '@/services'

export const QuotationsModal = ({
  quotations,
  isOpen,
  onHandleClose,
}: QuotationsModalProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('componentsQuotationsModal')

  const { data } = useSaleOrderVariantList({
    variantFields: 'simplifiedList',
    quotation_Uuid:
      quotations?.map((quotation) => quotation.uuid).join(',') || '',
  })

  return (
    <Modal.Root isOpen={!!isOpen} onHandleOpen={onHandleClose} size="small">
      <div className={styles.header}>
        <div className={styles.title}>
          <Text variant="text-large-bold">{t('title')}</Text>
        </div>
        <Text variant="text-base">{t('subtitle')}</Text>
      </div>
      <Modal.Body>
        <div className={styles.container}>
          {quotations?.map((quotation, index) => (
            <div key={index} className={styles.card}>
              <div>
                <Text variant="text-base" className={styles['card-label']}>
                  <strong>{t('referenceLabel')} </strong>#{quotation?.reference}
                </Text>
                <div>
                  <Text variant="text-base" className={styles['card-label']}>
                    <strong>{t('statusLabel')} </strong>
                    {tEnums(`quotation_status_${quotation?.status}`)}
                  </Text>
                </div>
              </div>
              <Button
                variant="secondary"
                target="_blank"
                href={ROUTES_ADMIN.BUSINESS.QUOTATION.SHOW.fullPath(
                  quotation?.uuid || '',
                )}
                model="square"
              >
                {t('viewButton')}
              </Button>
            </div>
          ))}
          {data?.data?.results?.map((saleOrder, index) => (
            <div key={index} className={styles.card}>
              <div>
                <Text variant="text-base" className={styles['card-label']}>
                  <strong>{t('referenceSOLabel')} </strong>#
                  {saleOrder?.reference}
                </Text>
                <div>
                  <Text variant="text-base" className={styles['card-label']}>
                    <strong>{t('statusSOLabel')} </strong>
                    {tEnums(`sale_order_status_${saleOrder?.status}`)}
                  </Text>
                </div>
              </div>
              <Button
                variant="secondary"
                target="_blank"
                href={ROUTES_ADMIN.ORDER_CENTER.ALL.SHOW.fullPath(
                  saleOrder?.uuid || '',
                )}
                model="square"
              >
                {t('viewButton')}
              </Button>
            </div>
          ))}
          <Button
            className={styles['header-close-button']}
            variant="secondary"
            onClick={onHandleClose}
          >
            {t('closeButton')}
          </Button>
        </div>
      </Modal.Body>
    </Modal.Root>
  )
}
